module.exports = __webpack_public_path__ + "sk.svg?fc341bbeac39b3127714b9906dd96980";